import { useState } from "react";
import { motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { grantPixelConsent, revokePixelConsent } from "@/lib/metaPixel";

const KEY = "sora_meta_consent";

export function usePixelConsent() {
  const [consent, setConsent] = useState(() => window.localStorage.getItem(KEY) || "unknown");

  const choose = (value) => {
    window.localStorage.setItem(KEY, value);
    setConsent(value);
    if (value === "accepted") grantPixelConsent();
    else revokePixelConsent();
  };

  return { consent, choose };
}

export default function ConsentBanner({ onChoice }) {
  return (
    <motion.div
      data-testid="consent-banner"
      initial={{ y: 80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t-2 border-hanko shadow-[0_-12px_40px_-12px_rgba(18,18,18,0.25)]"
    >
      <div className="max-w-4xl mx-auto px-5 py-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={20} className="text-hanko shrink-0 mt-0.5" />
          <p className="text-sm text-charcoal/80 leading-relaxed">
            Folosim Meta Pixel pentru a măsura campaniile de pe Facebook și Instagram.
            Poți accepta sau refuza — site-ul funcționează la fel în ambele cazuri.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="consent-reject-button"
            onClick={() => onChoice("rejected")}
            className="border border-sumi/25 text-sumi text-sm font-semibold px-6 py-3 rounded-full hover:border-sumi transition-colors duration-300 min-h-[44px]"
          >
            Refuz
          </button>
          <button
            data-testid="consent-accept-button"
            onClick={() => onChoice("accepted")}
            className="bg-hanko text-washi text-sm font-semibold px-6 py-3 rounded-full hover:bg-hankodeep transition-colors duration-300 min-h-[44px]"
          >
            Accept
          </button>
        </div>
      </div>
    </motion.div>
  );
}
